import * as _ from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import actions from "@/actions";

import Panel from "../base/Panel";
import PanelButtons from "./panel-buttons";

const AlignPanel = ({ alignLights }) => (
    <Panel title="Align">
        {_.map(PanelButtons, (Button, name) => (
            <Button
                key={`align-type-${name}`}
                color="#FFF"
                title={`Align ${name}`}
                className="tools-bar-button"
                onClick={() => alignLights(name.toLowerCase())}
            />
        ))}
    </Panel>
);

AlignPanel.propTypes = {
    alignLights: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    alignLights: actions.map.values.mode.alignLights,
};
export default connect(mapStateToProps, mapDispatchToProps)(AlignPanel);
